type ApiEsyoilSuccessResponse<ResponseData> = {
  meta: unknown;
  data: ResponseData;
  errors: boolean;
};

type ApiEsyoilResponse<ResponseData> =
  | ApiEsyoilError
  | ApiEsyoilErrorResponse
  | ApiEsyoilSuccessResponse<ResponseData>;

export type ApiEsyoilError = {
  error: boolean;
  message: string;
};

export type ApiEsyoilErrorResponse = {
  errors: {
    status: number;
    title: string;
    detail: string;
    message: string;
  }[];
};

export function isApiEsyoilError(
  response: ApiEsyoilResponse<unknown>,
): response is ApiEsyoilError {
  return (response as ApiEsyoilError).error !== undefined;
}

export function isApiEsyoilErrorResponse(
  response: ApiEsyoilResponse<unknown>,
): response is ApiEsyoilErrorResponse {
  return Array.isArray((response as ApiEsyoilErrorResponse).errors);
}

export type Dealer = {
  dea_id: string;
  pre_grade: number;
  dea_company: string;
  dea_company_short: string;
  dea_company_seo: string;
  pre_num_customer_rating_total: number;
  profile_slug: string;
  logoUrl: string;
};

export type UserRating = {
  rop_rating_value: string;
  rop_review_body: string;
  rop_date_created: string;
  tk_anrede: string;
  tk_ort: string;
};

export type TopDealerAndUserRatingsData = {
  dealerList: Dealer[];
  userRatings: UserRating[];
};

export type TopDealerAndUserRatingsResponse =
  ApiEsyoilResponse<TopDealerAndUserRatingsData>;

export type StateTopDealersResponse = ApiEsyoilResponse<Dealer[]>;
